import React, { useState, useEffect } from "react";
import { BackToTopWrapper } from "./BackToTopBtn.styled";

const BackToTopBtn = () => {
  const [isBackToTopVisible, setBackToTopVisibility] = useState(false);

  useEffect(() => {
    const handleWindowScroll = () => {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      //Show when 75% of top page is no longer visible
      const showAt = 0.75 * window.innerHeight;
      //Hide when only 50% of top page is not shown
      const hideAt = 0.5 * window.innerHeight;
      //no need to refire this if back to top is already visible
      if (!isBackToTopVisible && scrollTop >= showAt) {
        setBackToTopVisibility(true);
      }
      //no need to refire this if back to top is already hidden
      if (isBackToTopVisible && scrollTop < hideAt) {
        setBackToTopVisibility(false);
      }
    };
    window.addEventListener("scroll", handleWindowScroll);

    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    };
  }, [isBackToTopVisible]);

  return (
    <BackToTopWrapper
      data-testid="back-to-top"
      $isVisible={isBackToTopVisible}
      glyph="arrow_upward"
    />
  );
};

export default BackToTopBtn;
